import request from '../util/request.js'

export function getNewsList(data){
    return request({
        url : '/news/list',
        method: 'post',
        data
    })
}
//导航栏,手风琴
export function getNavTitle(){
    return request({
        url: '/default/type/tree/list',
        method: 'post'
    })
}
//根据ID搜索产品详情
export function getProduct(data){
    return request({
        url:'/product/list',
        method:'post',
        data
    })
}
//公司信息
export function getCompany(){
    return request({
        url:'/company/info/list',
        method:'post'
    })
}
//主题模块查询
export function getTheme(data){
    return request({
        url:'/theme/list',
        method:'post',
        data
    })
}
//搜索新闻ID
export function getNewsId(data){
    return request({
        url:'/news/id',
        method : 'post',
        data
    })
}

//首页设备
export function getShowEq(){
    return request({
        url:'/show/equipment',
        method : 'post'
    })
}